























import {Component, Emit, Model, Prop, Vue} from "vue-property-decorator";
import {RegionStore} from "../store";
import CountryLabel from "../CountryLabel/index.vue";
import {toSlug} from "@/shared/services/helper/utils";

@Component({
    name: "CountrySelector",
    components: {CountryLabel}
})
export default class extends Vue {
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
    @Prop({default: 'default'}) readonly size!: 'default' | 'small' | 'large';
    @Model("change", { type: Number })
    readonly countryId!: number;

    @Emit('change')
    handleChange(value: number) {
        return value;
    }

    get countryIds(): number[] {
        return RegionStore.countryIds;
    }

    async created() {
        try {
            if (!RegionStore.countryIds?.length)
                await RegionStore.getCountries();
        } catch (e) {
            this.$notification.error({ message: "Thất bại", description: e?.response?.data?.message || "Đã có lỗi xảy ra" });
        }
    }

    private filterOption(input: string, option: any) {
        return (toSlug(option.componentOptions.children[0].elm.textContent, " ")
                .toLowerCase()
                .indexOf(toSlug(input, " ")
                .toLowerCase()) >= 0);
    }
}
